import { Button, Image, UIHeading3 } from '@cian/ui-kit';

import { type FC } from 'react';

import errImg from './err.png';

import styles from './MapError.css';

type MapErrorProps = {
  errorMessage?: string;
  onRetry?: VoidFunction;
};

export const MapError: FC<MapErrorProps> = props => {
  const { errorMessage = 'Что-то пошло не так', onRetry } = props;

  return (
    <article className={styles['container']}>
      <div className={styles['image-wrapper']}>
        <Image alt="Ошибка загрузки карты" height={80} src={errImg} theme="light" width={80} />
      </div>

      <UIHeading3 as="h3">{errorMessage}</UIHeading3>

      {onRetry && (
        <Button size="M" onClick={onRetry}>
          Обновить
        </Button>
      )}
    </article>
  );
};
